import type { QuestionContext } from '@webapp/survey/src/machine/question-machine';

export const setAnsweredCount = (q: QuestionContext, num: number) => {
    // FIXME
    q.answeredCount = num;
};

export const calcAndSetAnsweredCount = (q: QuestionContext) => {
    const answeredCount = q.answersActors.reduce((acc, aActor) => {
        const { response } = aActor.getSnapshot().context;
        const { value } = response.getSnapshot().context;

        if (value) {
            acc += 1;
        }

        return acc;
    }, 0);

    setAnsweredCount(q, answeredCount);
};
